const creditLimitCCA = (value: string | null) => {
  if (!value) return "Value must not be empty"

  if (Number(value) > 10) {
    return `The maximum credit limit amount is £10`
  }

  return true
}

const creditLimitSeniorCCA = (value: string | null) => {
  if (!value) return "Value must not be empty"

  if (Number(value) > 50) {
    return `The maximum credit limit amount is £50`
  }

  return true
}
export { creditLimitCCA, creditLimitSeniorCCA }
